import { render, staticRenderFns } from "./RegistroComprobantesV.vue?vue&type=template&id=611f1329"
import script from "./RegistroComprobantesV.vue?vue&type=script&lang=js"
export * from "./RegistroComprobantesV.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports